import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import AppReviews from 'apps/promo/components/common/app-reviews/AppReviews';
import promoMedia from 'apps/promo/theme/promoMedia';

import AppDownloadButtons from '../app-download-buttons/AppDownloadButtons';
import GetStartedButton from '../get-started-button/GetStartedButton';
import PromoButtonExtended from '../promo-button/PromoButtonExtended';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';

const HeadingContainer = styled.div`
    padding: ${(props) => (props.$noTopIndent ? '0 0 32px 0' : '32px 0')};
    margin-bottom: ${(props) => (props.$noBottomIndent ? null : '16px')};
    text-align: ${(props) => (props.$textLeft ? 'left' : 'center')};

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.$noTopIndent ? '0 0 48px 0' : props.$textLeft ? '48px 0' : '48px')};
        margin-bottom: ${(props) => (props.$noBottomIndent ? null : '24px')};
    }

    ${promoMedia.desktop1440} {
        padding: ${(props) => (props.$noTopIndent ? '0 0 64px 0' : props.$textLeft ? '64px 0' : '64px')};
        margin-bottom: ${(props) => (props.$noBottomIndent ? null : '32px')};
    }
`;

const HeadingTitle = styled.div`
    margin-bottom: ${(props) => (props.$hasText ? '8px' : null)};

    ${promoMedia.tablet744} {
        margin-bottom: ${(props) => (props.$hasText ? '12px' : null)};
    }

    ${promoMedia.desktop1440} {
        margin-bottom: ${(props) => (props.$hasText ? '16px' : null)};
    }
`;

const BtnContainer = styled.div`
    margin-top: 16px;
    min-height: 40px;
    text-align: center;

    ${promoMedia.tablet744} {
        margin-top: 24px;
    }

    ${promoMedia.desktop1440} {
        margin-top: 32px;
        min-height: 48px;
    }
`;
const DemoWrapper = styled.div`
    margin-left: 16px;
    display: inline-block;
`;
const HeadingSection = ({ titleVariant = 'h2', hasAppsBtns = false, ...props }) => {
    return (
        <HeadingContainer $noBottomIndent={props.noBottomIndent} $textLeft={props.textLeft} $noTopIndent={props.noTopIndent} data-testid={props.dataTestId}>
            {hasAppsBtns && <AppReviews />}
            {props.title && (
                <HeadingTitle $hasText={props.text}>
                    <PromoDangerouslyHtml
                        tag={props.titleTag ?? 'h2'}
                        variant={titleVariant}
                        color={props.whiteTitle ? 'white' : 'gray80'}
                        dangerouslyHtml={props.title}
                    />
                </HeadingTitle>
            )}
            {props.text && (
                <PromoDangerouslyHtml
                    dangerouslyHtml={props.text}
                    tag="div"
                    variant={props.bodyText ? 'div' : 'subheader'}
                    color={props.whiteText ? 'white' : 'gray40'}
                />
            )}
            {(props.btn || props.demoBtn) && (
                <BtnContainer>
                    {props.btn.isExternalButton ? (
                        <GetStartedButton buttonText={props.btn?.title} />
                    ) : (
                        <>
                            {props.btn && (
                                <PromoButtonExtended
                                    btn={props.btn}
                                    btnMobile={props.btnMobile}
                                    isMobileBtn={props.isMobileBtn}
                                    iconName={props.iconName}
                                    variant={props.variant}
                                    isInverted={props.isInverted}
                                    sendFrom={props.sendFrom}
                                />
                            )}
                            {props.demoBtn && (
                                <DemoWrapper>
                                    <PromoButtonExtended
                                        btn={props.demoBtn}
                                        btnMobile={props.btnMobile}
                                        isMobileBtn={props.isMobileBtn}
                                        iconName={props.iconName}
                                        variant={props.variant}
                                        sendFrom={props.sendFrom}
                                    />
                                </DemoWrapper>
                            )}
                        </>
                    )}
                </BtnContainer>
            )}
            {hasAppsBtns && <AppDownloadButtons isReferral={props.isReferral} />}
        </HeadingContainer>
    );
};

HeadingSection.propTypes = {
    titleTag: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    iconName: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    btn: PropTypes.object,
    demoBtn: PropTypes.object,
    btnMobile: PropTypes.object,
    isMobileBtn: PropTypes.bool,
    noBottomIndent: PropTypes.bool,
    whiteTitle: PropTypes.bool,
    titleVariant: PropTypes.oneOf(['h2', 'h3']),
    textLeft: PropTypes.bool,
    bodyText: PropTypes.bool,
    dataTestId: PropTypes.string,
    hasAppsBtns: PropTypes.bool,
    isReferral: PropTypes.bool,
};

export default HeadingSection;
